import React from 'react';
import { getDisplayName } from '../../../utils/displayNameMapper';

interface WizardSearchStep1Props {
    onSelect: (selectedKey: string, isDynamicCollection?: boolean) => void;
    onNext: () => void;
    data: Record<string, any>;
    dynamicCollections: any[];
}

const WizardSearchStep1: React.FC<WizardSearchStep1Props> = ({
                                                                 onSelect,
                                                                 onNext,
                                                                 data,
                                                                 dynamicCollections,
                                                             }) => {
    const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;
        if (value.startsWith('dynamic:')) {
            const selectedKey = value.replace('dynamic:', '');
            onSelect(selectedKey, true);
        } else {
            onSelect(value, false);
        }
        onNext();
    };

    return (
        <div>
            <br />
            <h4>Step 1: Choose a Data Type</h4>
            <select onChange={handleSelect}>
                <option value="">Select an object</option>
                {Object.keys(data).map((key, index) => (
                    <option key={`static-${index}`} value={key}>
                        {getDisplayName(key)}
                    </option>
                ))}
                {dynamicCollections.map((collection, index) => (
                    <option key={`dynamic-${index}`} value={`dynamic:${collection.collection_name}`}>
                        Dynamic: {collection.collection_name}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default WizardSearchStep1;
